<template>
    <v-modal title="Cancel Order" @close="$emit('close')" cancel-label="Close" :scroll="true">
        <div slot="contents">
            <div class="modal-content">
                <h3 class="stack-m">Effective Date</h3>
                <div class="grid-content">
                    <div v-for="(option, index) in effectiveDateOptions" class="grid-item grid-item-full" :key="index">
                        <v-radio
                            group="effectiveDate"
                            :label="option.label"
                            :value="option.value"
                            :model="effectiveDate"
                            :class="{'stack-s': option.value === effectiveDates.now}"
                            @update="updateEffectiveDate"/>
                        <v-checkbox
                            v-if="option.value === effectiveDates.now"
                            :disabled="!isEffectiveNow"
                            class="margin-left-default"
                            label="With pro rata credit"
                            :value="true"
                            v-model="cancellation.prorated"/>
                    </div>
                </div>
            </div>
            <div class="modal-content">
                <h3 class="stack-m">Cancellation Information</h3>
                <div class="grid-content">
                    <div class="grid-item grid-item-full">
                        <label>Canceled By</label>
                    </div>
                    <div v-for="(option, index) in canceledByOptions" class="grid-item grid-item-full" :key="index">
                        <v-radio
                            group="canceledBy"
                            :label="option.label"
                            :value="option.value"
                            :model="cancellation.canceledBy"
                            @update="cancellation.canceledBy = $event"/>
                    </div>
                    <div class="grid-item grid-item-full">
                        <v-select
                            label="Cancellation Reason"
                            v-model="cancellation.reason"
                            :options="cancellationReasonOptions"/>
                    </div>
                    <div class="grid-item grid-item-full">
                        <r-input
                            class="stack-m"
                            label="Description"
                            multiline
                            rows="3"
                            v-model="cancellation.description"/>
                    </div>
                </div>
            </div>
            <div class="modal-content">
                <v-checkbox
                    label="Send email to customer"
                    v-model="sendEmail"
                    :value="true"
                    caption="Notify the customer by email that his order was canceled."
                />
            </div>
        </div>
        <template slot="actions">
            <r-button type="primary" @click="cancelOrder">Cancel Order</r-button>
        </template>
    </v-modal>
</template>

<script>
    import {
        vCheckbox, vRadio, vSelect,
    } from '@/components/form';
    import vModal from '@/components/modal/v-modal';
    import format from '@/common/format';
    // import moment from 'moment';
    import _ from '@/common/helpers';
    import OrderCancellationModel from '@/common/models/order-cancellation-model';

    const effectiveDates = {
        atNextRenewal: 'atNextRenewal',
        now: 'now',
    };

    export default {
        name: 'cancel-modal',
        inject: ['cancel'],
        props: {
            order: Object,
        },
        components: {
            vModal,
            vRadio,
            vCheckbox,
            vSelect,
        },
        computed: {
            effectiveDateOptions() {
                return [
                    {
                        label: `At next renewal (${format.dateTime(this.order.renewalTime)})`,
                        value: effectiveDates.atNextRenewal,
                    },
                    {label: `Now`, value: effectiveDates.now},
                ];
            },
            isEffectiveNow() {
                return this.effectiveDate === effectiveDates.now;
            },
        },
        data() {
            return {
                cancellation: new OrderCancellationModel({
                    subscriptionId: this.order.id,
                    churnTime: this.order.renewalTime,
                }),
                sendEmail: false,
                effectiveDate: effectiveDates.atNextRenewal,
                effectiveDates,
                canceledByOptions: [
                    {label: `Customer`, value: OrderCancellationModel.CancelEntities.customer},
                    {label: `Merchant`, value: OrderCancellationModel.CancelEntities.merchant},
                ],
                cancellationReasonOptions: Object
                    .values(OrderCancellationModel.Reasons)
                    .map(reason => ({label: _.unKebabCase(reason), value: reason})),
            };
        },
        methods: {
            updateEffectiveDate(date) {
                this.effectiveDate = date;
                if (date === effectiveDates.atNextRenewal) {
                    this.cancellation.prorated = false;
                    this.cancellation.churnTime = this.order.renewalTime;
                } else {
                    this.cancellation.churnTime = this.$tz().now().format();
                }
            },
            cancelOrder() {
                this.cancel({data: this.cancellation.getPayload(), sendEmail: this.sendEmail});
                this.$emit('close');
            },
        },
    };
</script>
